export const navigateBack = (defaultBackRoute: string, history: any, location: any) => {
    const state: any = location.state;

    if (state && state.internal === true)
        history.goBack();
    else 
        history.push(defaultBackRoute);
};

export const navigateTo = (route: string, history: any) => {
    history.push(route, { internal: true });
};